export default "/images/mydock-logo.jpg?0685398462bc83c2baf2e354008fff1f";